// Meta Pixel helper — eventos padrão + event_id para deduplicação com CAPI.
// Nenhum segredo aqui — o Pixel ID é público por definição.

function newEventId() {
  // UUID v4 — determinístico o suficiente para dedupe entre browser e server.
  if (crypto?.randomUUID) return crypto.randomUUID();
  return "evt-" + Math.random().toString(16).slice(2) + Date.now().toString(16);
}

function fbq(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") window.fbq(...args);
}

export function trackPageView() {
  fbq("track", "PageView");
}

export function trackCompleteRegistration({ method } = {}) {
  const eventID = newEventId();
  fbq("track", "CompleteRegistration",
    { content_name: "AulaPronta", status: "completed", method },
    { eventID });
  return eventID;
}

export function trackInitiateCheckout({ value = 19.9, currency = "BRL" } = {}) {
  const eventID = newEventId();
  fbq("track", "InitiateCheckout",
    { value, currency, content_name: "AulaPronta Premium",
      content_category: "subscription", content_type: "product" },
    { eventID });
  return eventID;
}

/**
 * Dispara Purchase no browser com o MESMO event_id usado pelo servidor
 * (vem do backend ao ativar o Premium) — Meta deduplica automaticamente.
 */
export function trackPurchase({ eventID, value = 19.9, currency = "BRL" }) {
  if (!eventID) return;
  fbq("track", "Purchase",
    { value, currency, content_name: "AulaPronta Premium",
      content_category: "subscription", content_ids: ["aulapronta_premium"],
      content_type: "product" },
    { eventID });
}
